module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-1800.f71a46d7.svg";